import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { globalPlatformGuard } from './core/guards/global-platform.guard';
import { CierrapuertasOfertasComponent } from './public/cierrapuertas-ofertas/cierrapuertas-ofertas.component';
import { CierrapuertasComponent } from './public/cierrapuertas/cierrapuertas.component';
import { CitaComponent } from './public/cita/cita.component';
import { CondicionesDeReservaComponent } from './public/condiciones-de-reserva/condiciones-de-reserva.component';
import { ConformidadComponent } from './public/conformidad/conformidad.component';
import { DocumentacionViajeComponent } from './public/documentacion-viaje/documentacion-viaje.component';
import { HomeContentComponent } from './public/home/components/home-content/home-content.component';
import { HomeComponent } from './public/home/home.component';
import { NuestraEmpresaComponent } from './public/nuestra-empresa/nuestra-empresa.component';
import { PoliticasComponent } from './public/politicas/politicas.component';
import { ResponsabilidadSocialComponent } from './public/resonsabilidad-social/responsabilidad-social.component';
import { BenefitsComponent } from './public/retail/benefits/benefits.component';
import { RetailComponent } from './public/retail/retail.component';
import { PageNotFoundComponent } from './shared/components/moleculas/page-not-found/page-not-found.component';
import { CanActivateCheckoutGuard } from './shared/guards/checkout.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [globalPlatformGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        children: [
          {
            matcher: (segments) => {
              if (segments.length > 1) return null;

              const paths = ['vuelos', 'paquetes', 'hoteles', 'vuelohotel', 'seguro-viaje'];
              const path = segments[0]?.path;

              if (segments.length === 0 || paths.includes(path)) {
                return { consumed: segments };
              }

              return null;
            },
            component: HomeContentComponent,
          },
        ],
      },
      {
        path: 'booking/v2',
        loadChildren: () => import('./public/booking/booking.module').then((m) => m.BookingModule),
      },
      {
        path: 'mejor-opcion/:origin/:destination',
        loadComponent: () =>
          import('./public/best-flight/best-flight.component').then((c) => c.BestFlightComponent),
      },
      {
        path: 'seguros',
        loadChildren: () =>
          import('./public/insurance/insurance.module').then((m) => m.InsuranceModule),
      },
      {
        path: 'perfil',
        loadChildren: () => import('./private/perfil/perfil.module').then((m) => m.PerfilModule),
      },
      {
        path: 'traveloutlet',
        loadComponent: () =>
          import('./public/travel-outlet/travel-outlet.component').then(
            (c) => c.TravelOutletComponent,
          ),
      },
      {
        path: 'recepcion',
        loadChildren: () =>
          import('./public/tottem-digital/tottem-digital.module').then(
            (m) => m.TottemDigitalModule,
          ),
      },
      {
        path: 'eventos',
        loadChildren: () => import('./public/eventos/eventos.module').then((m) => m.EventosModule),
      },
      {
        path: 'promociones',
        loadChildren: () =>
          import('./public/promociones/promociones.module').then((m) => m.PromocionesModule),
      },
      {
        path: 'suscribirse',
        loadChildren: () =>
          import('./public/subscription/subscription.module').then((m) => m.SubscriptionModule),
      },
      {
        path: 'canales-de-atencion',
        loadChildren: () =>
          import('./public/canales-atencion/canales-atencion.module').then(
            (m) => m.CanalesAtencionModule,
          ),
      },
      {
        path: 'resultados',
        loadChildren: () => import('./public/flight-results').then((m) => m.FlightResultsModule),
      },
      { path: 'agenda-tu-cita', component: CitaComponent },
      { path: 'conformidad', component: ConformidadComponent },
      {
        path: 'terminos-condiciones',
        loadComponent: () =>
          import('./public/terms-conditions/terms-conditions.component').then(
            (c) => c.TermsConditionsComponent,
          ),
      },
      { path: 'documentacion-viaje', component: DocumentacionViajeComponent },
      { path: 'documentacion_de_viaje.html', component: DocumentacionViajeComponent },
      { path: 'confirmacion/:id', component: HomeComponent },
      {
        path: 'vuelos/:slug',
        loadComponent: () =>
          import('./public/landings/pages/destination/destination.component').then(
            (c) => c.DestinationComponent,
          ),
      },
      { path: 'armapaquete', component: HomeComponent },
      { path: 'autos', component: HomeComponent },
      { path: 'actividades', component: HomeComponent },
      { path: 'nuestra-empresa', component: NuestraEmpresaComponent },
      {
        path: 'nuestras-agencias',
        loadComponent: () =>
          import('./public/agencies/agencies.component').then((c) => c.AgenciesComponent),
      },
      { path: '28-de-julio', component: RetailComponent },
      { path: 'beneficios', component: BenefitsComponent },
      {
        path: 'libro-reclamaciones',
        loadComponent: () =>
          import('./public/complaint-book/complaint-book.component').then(
            (c) => c.ComplaintBookComponent,
          ),
      },
      { path: 'cierrapuertas', component: CierrapuertasComponent },
      { path: 'cierrapuertas/ofertas', component: CierrapuertasOfertasComponent },
      {
        path: 'tusdatos',
        loadComponent: () =>
          import('./public/pre-register/pre-register.component').then(
            (c) => c.PreRegisterComponent,
          ),
      },
      { path: 'politicas', component: PoliticasComponent },
      { path: 'condiciones-de-reserva', component: CondicionesDeReservaComponent },
      { path: 'responsabilidad-social', component: ResponsabilidadSocialComponent },
      {
        path: 'tuscitas',
        loadChildren: () =>
          import('./public/tuscitas/tuscitas.module').then((m) => m.TuscitasModule),
      },
      {
        path: 'booking',
        loadChildren: () =>
          import('./public/checkout-page/checkout.module').then((m) => m.CheckoutPageModule),
        canActivate: [CanActivateCheckoutGuard],
      },
      {
        path:
          'booking/itinerary/:transactionId/:idGroup/:segments/:flightType/:departureLocation/:arrivalLocation/' +
          ':departureDate/:arrivalDate/:adults/:children/:infants/:flightClass',
        loadChildren: () =>
          import('./public/checkout-page/checkout.module').then((m) => m.CheckoutPageModule),
      },
      {
        path:
          'booking/itinerary/:transactionId/:idGroup/:segments/:flightType/:departureLocation/:arrivalLocation/' +
          ':departureDate/:arrivalDate/:adults/:children/:infants/:flightClass/:upsellName',
        loadChildren: () =>
          import('./public/checkout-page/checkout.module').then((m) => m.CheckoutPageModule),
      },
      {
        path: 'hoteles',
        loadChildren: () => import('./public/landings/pages').then((m) => m.HotelsModule),
      },
      {
        path: 'paquetes',
        loadChildren: () => import('./public/landings/pages').then((m) => m.TravelPackagesModule),
      },
      {
        path: 'aerolinea',
        loadChildren: () => import('./public/landings/pages').then((m) => m.AirlinesModule),
      },
      {
        path: 'info',
        loadChildren: () => import('./public/landings/pages').then((m) => m.CampaignsModule),
      },
      {
        path: 'redireccionando',
        loadChildren: () =>
          import('./public/redirect/redirect.module').then((m) => m.RedirectModule),
      },
      { path: '404', component: PageNotFoundComponent },
      { path: '**', redirectTo: '404' },
    ],
  },
  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'top',
      initialNavigation: 'enabledBlocking',
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
